import React, {Fragment, useState, useEffect} from 'react'
import axios from 'axios';
import { Container,ContenedorPregunta,ContenedorPreguntas, Btnpreguntar, ContenedorSend,ContenedorGracias} from './styles'
import {Respuestas} from './respuestas'
import globals from 'react-global-configuration';

export const Encuesta = (props) => { 
    
    const _URL_REST = globals.get('_URL_REST');
    

    const [data, setData] = useState(null);
    const [showform, setshowform] = useState(true);
    const [question, setQuestion] = useState([]);
    const questionChange = (pregunta, respuesta,istexto = 0,valor= '') => {
        //console.log(pregunta +'-'+ respuesta)
        question.forEach((item, index) => {
            //console.log('item::',item)
            if(item.pregunta === pregunta){
                question.splice(index,1)
            }
        })
        if(istexto === 1){
            question.push({'pregunta': pregunta, 'respuesta': respuesta, 'comentario': valor})
        }else{
            question.push({'pregunta': pregunta, 'respuesta': respuesta, 'comentario': valor})
        }
        
        //console.log(question)
    }

    const saveQuestions = () => {

      
        if(question.length < data.length - 1){
            alert('Rellene todos los campos de la encuesta')
            return
        }
        question.forEach((element, index) => {

            const dataLog2 = {
                'usuario': ''+sessionStorage.getItem(`${process.env.REACT_APP_EVENTO_ID}index-Name_Id`),
                'pregunta': element.pregunta,
                'respuesta': element.respuesta,
                'comentario': element.comentario,
            };
            axios.post(
                `${_URL_REST}/guardarespuesta/`,
                dataLog2 
            ).then(res => {
               //console.log('insert')
               setshowform(false)
            })

        })
       // console.log('end')
    }
    
    


    useEffect(() => {
        async function fetchData() {
          // You can await here
          let idevento = props.idevento
          const result = await axios(
            `${_URL_REST}/getencuesta/${idevento}`,
        );
        //console.log('result:::',result)   
        setData(result.data);
        //console.log('DATA::::',result.data)
        }
        fetchData();
    }, [props.idevento,_URL_REST]);

    if (!data) {
        return <div></div>  
    }

 
    

    return (
        <Fragment>
        {showform ?
           <Container className={props.showdiv ? 'hides animated': 'shows animated'}>
                <form action="#">
                    {
                        
                        data
                        .map(item => 
                           
                            <ContenedorPreguntas key={'key'+item.id}>
                                <ContenedorPregunta>{item.texto}</ContenedorPregunta>
                                <Respuestas questionChange={questionChange} idpregunta={item.id} />
                            </ContenedorPreguntas>
                            
                        )
                    }
                    <ContenedorSend> <Btnpreguntar  onClick={()=>{ saveQuestions() }} >Enviar</Btnpreguntar></ContenedorSend>
                </form>
           </Container>
           : <Container className={props.showdiv ? 'hides animated': 'shows animated'}><ContenedorGracias>Gracias por enviarnos tu opinión</ContenedorGracias></Container>}
        </Fragment>
    )
}
